
var id = "modalClose";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1030 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"modalClose\"><path d=\"M566.613 512l279.894-279.893c13.653-13.654 13.653-34.134 0-47.787-13.654-13.653-34.134-13.653-47.787 0L512 457.387 238.933 184.32c-13.653-13.653-34.133-13.653-47.786 0-13.654 13.653-13.654 34.133 0 47.787L471.04 512 191.147 791.893c-13.654 13.654-13.654 34.134 0 47.787 13.653 13.653 34.133 13.653 47.786 0l279.894-279.893L798.72 839.68c13.653 13.653 34.133 13.653 47.787 0 13.653-13.653 13.653-34.133 0-47.787L566.613 512z m0 0\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
